<div class="container" *ngIf="jobDetails">
    <div class="row">
        <div class="col-md-6 col-md-offset-3 col-xs-12">
            <div class="detail-title">
                <h1 [innerHtml]="jobDetails['jobTitle'] | safe: 'html'"></h1>
                <p [innerHtml]="buildAddressString(jobDetails) | safe: 'html'"></p>
                <p *ngIf="jobDetails.categories" [innerHtml]="buildCategoryString(jobDetails) | safe:'html'"></p>
            </div>
            <div class="detail-posting">
                <p><strong>Job Description</strong></p>
                <div [innerHTML]="jobDetails['jobDescription']"></div>
                <p *ngIf="jobDetails['qualifications']['jobRequirement']"><strong>Requirements</strong></p>
                <div *ngIf="jobDetails['qualifications']['jobRequirement']" [innerHTML]="jobDetails['qualifications']['jobRequirement']"></div>
                <p *ngIf="wageString"><strong>Wage</strong></p>
                <div *ngIf="wageString" [innerHTML]="wageString"></div>
                <p *ngIf="jobDetails['qualifications']['jobBenefits']"><strong>Additional Info</strong></p>
                <div *ngIf="jobDetails['qualifications']['jobBenefits']" [innerHTML]="jobDetails['qualifications']['jobBenefits']"></div>
            </div>

            <job-detail-seo [jobDetails]="jobDetails"></job-detail-seo>
        </div>
    </div>
</div>

<div StickyScroll [top]="false" class="apply-container" *ngIf="jobDetails">
    <share-button *ngIf="showShare" [job]="jobDetails" [themeColor]="site['theme']['buttonColor']" [openUp]="true"></share-button>
    <apply-button *ngIf="isExternalApply" [themeColor]="site['theme']['buttonColor']" [buttonText]="'Apply Now'" (click)="applyContinueClick()"></apply-button>
    <apply-button *ngIf="!isExternalApply" [themeColor]="site['theme']['buttonColor']" [buttonText]="'Apply via Snagajob'" (click)="toggleApplyModal()"></apply-button>
</div>


<modal id="apply-modal" *ngIf="jobDetails" [visible]="showApplyModal" [showFooter]="false" (close)="toggleApplyModal()">

    <header>
        <h2>Apply via Snagajob</h2>
    </header>

    <content>
      <div>
        <p>You’re being directed to the Snagajob website to apply for this {{ jobDetails['jobTitle'] }} position. If you’re not already logged in, you’ll have the option to sign in or create an account to start the application.</p>
        <a class="btn" [style.background-color]="site['theme']['buttonColor']" (click)="applyContinueClick()">
            <strong>Continue</strong>
        </a>
      </div>
    </content>


</modal>



<customer-site-page-not-found *ngIf="!jobDetails" [themeColor]="site['theme']['buttonColor']" [site]="site"></customer-site-page-not-found>
